import { initializeApp } from "firebase/app";
import {
  getFirestore,
  updateDoc,
  doc,
  setDoc,
  getDoc,
  deleteDoc,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import "firebase/compat/storage";
import { ref, deleteObject, listAll } from "firebase/storage";
const firebaseConfig = {
  apiKey: "AIzaSyCLm1QDvMcjWmgRxLuFe37XTX00U_Y9Lko",
  authDomain: "partenope-c3453.firebaseapp.com",
  projectId: "partenope-c3453",
  storageBucket: "partenope-c3453.firebasestorage.app",
  messagingSenderId: "687418306372",
  appId: "1:687418306372:web:85d29c9ff5693b52e7f111",
  measurementId: "G-0JS4PZYY5V",
};
// TODO: Add SDKs for Firebase products that you want to use
export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const db = getFirestore(app);

export async function updateAvailability(
  titolo,
  indirizzo,
  prezzo,
  grandezza,
  camere,
  bagni,
  piano,
  dettagli,
  contratto,
  descrizione,
  pianiEdificio,
  ascensore,
  superficie,
  locali,
  cucina,
  arredato,
  balcone,
  terrazzo,
  riscaldamento,
  climatizzazione,
  speseCondominio,
  classeEnergetica,
  condizioni
) {
  try {
    const propertyRef = doc(db, "immobili", titolo.toString());
    const propertyDoc = await getDoc(propertyRef);

    if (!propertyDoc.exists()) {
      console.log("Creazione di un nuovo immobile.");
      await setDoc(propertyRef, {
        titolo,
        indirizzo,
        prezzo,
        grandezza,
        camere,
        bagni,
        piano,
        dettagli,
        contratto,
        descrizione,
        pianiEdificio,
        ascensore,
        superficie,
        locali,
        cucina,
        arredato,
        balcone,
        terrazzo,
        riscaldamento,
        climatizzazione,
        speseCondominio,
        classeEnergetica,
        condizioni,
      });
    } else {
      console.log("L'immobile esiste già. Aggiornamento in corso.");
      await updateDoc(propertyRef, {
        titolo,
        indirizzo,
        prezzo,
        grandezza,
        camere,
        bagni,
        piano,
        dettagli,
        contratto,
        descrizione,
        pianiEdificio,
        ascensore,
        superficie,
        locali,
        cucina,
        arredato,
        balcone,
        terrazzo,
        riscaldamento,
        climatizzazione,
        speseCondominio,
        classeEnergetica,
        condizioni,
      });
    }
  } catch (error) {
    console.error("Errore durante il caricamento dell'immobile:", error);
  }
}
export async function deleteProperty(titolo) {
  try {
    // Riferimento al documento dell'immobile
    const propertyRef = doc(db, "immobili", titolo.toString());

    // Ottieni il documento per vedere se esiste
    const propertyDoc = await getDoc(propertyRef);

    if (propertyDoc.exists()) {
      // Elimina il documento dalla collezione "immobili"
      await deleteDoc(propertyRef);
      console.log(`Documento con titolo ${titolo} eliminato da Firestore.`);

      // Elimina le immagini correlate (se esistono)
      const imagesRef = ref(storage, `properties/${titolo}`);
      const imagesSnapshot = await listAll(imagesRef); // Prendi tutti i file nella cartella del titolo
      const deletePromises = imagesSnapshot.items.map((imageRef) => {
        return deleteObject(imageRef);
      });

      // Elimina tutte le immagini dalla cartella
      await Promise.all(deletePromises);
      console.log(
        `Immagini associate all'immobile con titolo ${titolo} eliminate dallo storage.`
      );
    } else {
      console.log(`Immobile con titolo ${titolo} non trovato.`);
    }
  } catch (error) {
    console.error("Errore durante l'eliminazione dell'immobile:", error);
  }
}
